export interface ConsigConciliationFilters {
  dateRange?: string[];
  promotora: string;
  corban: string;
  vendedor: string;
  gerenteComercial: string;
  proposalIdOrShorthash: string;
  seguradora: string;
  riskClassification: string;
  conciliationStatus: string;
}

export const initialConsigConciliationFilters: ConsigConciliationFilters = {
  dateRange: [],
  promotora: "",
  corban: "",
  vendedor: "",
  gerenteComercial: "",
  proposalIdOrShorthash: "",
  seguradora: "",
  riskClassification: "",
  conciliationStatus: "",
};
